module.exports = __webpack_public_path__ + "img/switzerland.69547e25.svg";